/**
 * Build-time configuration. Everything here ships inside the bundle and is readable by anyone
 * with the application open, so nothing secret is ever added to this file — see .env.example.
 */
export const env = {
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  environmentLabel: import.meta.env.VITE_ENVIRONMENT_LABEL ?? '',
  isProduction: import.meta.env.PROD,
} as const

/** Version segment every request goes through. v1 is frozen once the mobile app ships. */
export const API_VERSION = 'v1'

export const apiUrl = (path: string) => `${env.apiBaseUrl}/${API_VERSION}${path}`
